// extracted by mini-css-extract-plugin
export default {"heading":"gt-z","corrected":"ht-z","redirectVerbiageContainer":"it-z","redirectVerbiageText":"jt-z"};